var map = {
	"./1.jpg": 7394,
	"./10.jpg": 1232,
	"./11.jpg": 8333,
	"./2.jpg": 6621,
	"./3.jpg": 1728,
	"./4.jpg": 531,
	"./5.jpg": 6774,
	"./6.jpg": 2625,
	"./7.jpg": 820,
	"./8.jpg": 9255,
	"./9.jpg": 1514
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5210;